module.exports = "https://dashboard.cdn.gifty.nl/6114/images/gifty-logo.png?352b361b8ca132b5af0f30d6d0287c0f";